<template>
  <div data-testid="cycle-settings" class="cycle-settings">
    <div class="cycle-settings__header">
      <h3 data-testid="cycle-settings__title" class="cycle-settings__title">
        Cycle Settings
      </h3>
      <FcTabSwitcher
        :tabs="fcTabs"
        :value="activeTabId"
        variant="underline"
        aria-label="Cycle settings sections"
        data-testid="cycle-settings__tabs"
        @input="onTabChange"
      />
    </div>

    <div data-testid="cycle-settings__body" class="cycle-settings__body">
      <router-view />
    </div>
  </div>
</template>

<script>
import { FC_ROUTES } from '@/modules/financialclose/utils/constants';
import { FcTabSwitcher } from '@/modules/financialclose/components';

export default {
  name: 'CycleSettings',
  components: {
    FcTabSwitcher,
  },
  computed: {
    cycleId() {
      return this.$route.params.id || null;
    },
    fcTabs() {
      const id = this.cycleId;
      if (!id) return [];
      const tabs = [
        { id: 'team', label: 'Team' },
        { id: 'threshold', label: 'Thresholds' },
      ];
      tabs.push({ id: 'automations', label: 'Automations' });
      return tabs;
    },
    activeTabId() {
      const path = this.$route.path || '';
      const id = this.cycleId;
      if (!id) return null;
      if (path.includes(`/cycle-settings/${id}/threshold`)) return 'threshold';
      if (path.includes(`/cycle-settings/${id}/automations`)) return 'automations';
      if (path.includes(`/cycle-settings/${id}/team`)) return 'team';
      return 'team';
    },
  },
  methods: {
    onTabChange(tabId) {
      const id = this.cycleId;
      if (!id) return;
      const path = tabId === 'threshold'
        ? FC_ROUTES.CYCLE_SETTINGS_THRESHOLD(id)
        : tabId === 'automations'
          ? FC_ROUTES.CYCLE_SETTINGS_AUTOMATIONS(id)
          : FC_ROUTES.CYCLE_SETTINGS_TEAM(id);
      if (this.$route.path === path) return;

      // Preserve cid (and other query params) — bare router.push drops cid and
      // App.vue treats that as an entity switch (full page reload).
      const cid = this.$route.query.cid || this.$store.state.client;
      const query = { ...this.$route.query };
      if (cid) query.cid = String(cid);

      this.$router.push({ path, query }).catch((err) => {
        if (err?.name === 'NavigationDuplicated') return;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './CycleSettings.scss';
</style>
